import { useAppSelector } from '@/store/hooks/useAppSelector.js';
import { getLoggedInUser, getSelectedAgent } from '@/store/account/selector.js';
import { FC } from 'react';
import { useLocalTimezone } from 'src/common/hooks/useLocalTimezone.js';
import { getResellerData } from '@/store/reseller/selector.js';
import { MessageOutlined } from '@ant-design/icons';
import Header from '@/components/Header/Header.js';
import TextingPlatformArea from './TextingPlatFormArea.js';

export const TextingPlatform: FC<{ debrand: boolean; isNoviUser: boolean }> = ({ debrand }) => {
	const loggedInUser = useAppSelector(getLoggedInUser);
	const currentReseller = useAppSelector(getResellerData);
	const selectedAgent = useAppSelector(getSelectedAgent);

	const { timeZone } = useLocalTimezone(selectedAgent?.time_zone);

	return (
		<div>
			<Header
				title="Texting Platform"
				description="Send and receive text messages with ease"
				icon={<MessageOutlined />}
				debrand={debrand}
			/>
			<TextingPlatformArea
				themeColor={'#007bff'}
				premium_customer={
					loggedInUser.resellerClient ||
					(loggedInUser?.inboundSubscriptionStatus &&
						loggedInUser?.inboundSubscriptionStatus !== 'cancelled' &&
						selectedAgent?.type === 'Inbound') ||
					(selectedAgent?.type === 'Outbound' && !loggedInUser.outboundDemo)
				}
				theirNumber={selectedAgent?.number}
				username={selectedAgent?.number}
				selectedTimeZone={timeZone}
				resellerObject={currentReseller}
			/>
		</div>
	);
};
